<template>
  <div class="entry-page">
    <NavBar />
    <div class="about-page">
      <section v-if="carousel[0]" class="carouselStyle">
        <img
          class="computer"
          style="opacity: 0"
          :src="carousel[0].BannerPic"
          alt=""
        />
        <img
          class="mobile"
          style="opacity: 0"
          :src="carousel[0].BannerPicMobile"
          alt=""
        />
        <el-carousel :interval="5000" arrow="always">
          <el-carousel-item v-for="item in carousel" :key="item.Guid">
            <img class="computer" :src="item.BannerPic" alt="" />
            <img class="mobile" :src="item.BannerPicMobile" alt="" />
          </el-carousel-item>
        </el-carousel>
      </section>

      <div style="background-color: #fff; height: 30px"></div>

      <section class="job-section">
        <div class="title">
          <span>{{ i18n("Homepage.JobOpenings") }}</span>
        </div>
        <div class="job-list">
          <div class="row" style="margin-bottom: 5px">
            <div class="col-md-3">
              <input
                style="margin-bottom: 5px"
                type="text"
                class="form-control"
                :placeholder="i18n('Homepage.Keyword')"
                v-model.trim="searchCondition.manpowerDemandName"
                @keydown.stop.prevent.enter="getJobList"
              />
            </div>
            <div class="col-md-3">
              <select
                class="form-control"
                v-model="searchCondition.workPlace"
                style="margin-bottom: 5px"
              >
                <option :value="null">
                  {{ i18n("Homepage.NotSpecified") }}
                </option>
                <option
                  v-for="item in workPlaceList"
                  :key="item.Guid"
                  :value="item.WorkPlaceName"
                >
                  {{ item.WorkPlaceName }}
                </option>
              </select>
            </div>
            <div class="col-md-2">
              <button
                class="btn btn-sm w-100"
                @click="getJobList"
                style="
                  margin-bottom: 5px;
                  height: 37px;
                  background: #f54c4a;
                  color: #fff;
                "
              >
                <eva-icon name="search-outline" fill="#fff"></eva-icon>
                {{ i18n("Homepage.Search") }}
              </button>
            </div>
          </div>

          <div v-for="item in jobList" :key="item.No" class="job">
            <div class="date">
              <span class="year">{{ item.RecruitmentDeadline | year }}</span
              ><br />
              {{ item.RecruitmentDeadline | date }}
            </div>
            <div class="info">
              <div class="name">
                {{ item.ManpowerDemandName }}
                <eva-icon
                  name="question-mark-circle"
                  fill="red"
                  @click="jobModal(item)"
                ></eva-icon>
              </div>
              <div class="tag">
                <span v-for="place in item.WorkPlace" :key="place">{{
                  place
                }}</span>
                <span v-if="item.WorkExperienceWhatever">工作經驗不拘</span>
                <span v-else>{{ item.WorkExperience }} 年</span>
                <span v-if="item.EducationDemandWhatever">學歷不拘</span>
                <span
                  v-else
                  v-for="(education, index) in item.EducationDemand"
                  :key="index"
                >
                  {{ education }}
                </span>
              </div>
              <div class="desc">
                <pre style="font-size: 14px">{{ item.WorkContent }}</pre>
              </div>
            </div>
            <div class="edit">
              <button type="btn" class="btn" @click="apply(item.No)">
                {{ i18n("Homepage.Recruit") }}
              </button>
            </div>
          </div>
        </div>
      </section>

      <div
        class="modal fade"
        id="jobModal"
        tabindex="-1"
        aria-labelledby="jobModal"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <span class="modal-title">
                {{ job.ManpowerDemandName }}-職務說明
              </span>
            </div>
            <div class="modal-body">
              <span v-if="job.PositionInstruction === null">尚無說明</span>
              <pre v-else>{{ job.PositionInstruction }}</pre>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
/* global $ */
import moment from "moment";
import jwt_decode from "jwt-decode";

import NavBar from "@/components/HomePage/NavBar";
import Footer from "@/components/Layout/Footer";

window.history.forward(1);

export default {
  name: "HomePage",

  components: {
    NavBar,
    Footer,
  },
  data() {
    return {
      // 輪博
      carousel: [],

      // 區塊
      block: [],

      // 工作地點
      workPlaceList: [],

      // 職務說明
      job: {},

      // 職缺列表
      searchCondition: {},
      jobList: [],
      year: null, // 年
      date: null, // 日期
    };
  },

  filters: {
    year: function (date) {
      return moment(date).format("YYYY");
    },
    date: function (date) {
      return moment(date).format("MM/DD");
    },
  },

  methods: {
    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },
    // 職務說明
    jobModal(item) {
      $("#jobModal").modal("show");
      this.job = { ...item };
    },

    // 取得輪播
    getCarousel() {
      const vm = this;
      const api = `${window.endpoints.api}/FrontPageBanner`;

      vm.$http
        .get(api)
        .then((response) => {
          if (response.status === 200 && response.data.length > 0) {
            vm.carousel = response.data;
          }
        })
        .catch((error) => {
          vm.$notify({
            title: "輪播圖取得失敗",
            message: error.response.data,
            type: "error",
            duration: 0,
          });
        });
    },

    // 取得區塊
    getBlock() {
      const vm = this;
      const api = `${window.endpoints.api}/CompanyProfile`;

      vm.$http
        .get(api)
        .then((response) => {
          if (response.status === 200 && response.data.length > 0) {
            vm.block = response.data;
          }
        })
        .catch((error) => {
          vm.$notify({
            title: "區塊取得失敗",
            message: error.response.data,
            type: "error",
            duration: 0,
          });
        });
    },

    // 取得職缺列表 API
    getJobList() {
      const vm = this;
      const api = `${window.endpoints.api}/ManpowerDemandModule/Vacancies/paging`;

      const params = {
        IsPaging: false,
        ManpowerDemandName: vm.searchCondition.manpowerDemandName,
        workPlace: vm.searchCondition.workPlace,
      };

      vm.$http
        .get(api, { params })
        .then((response) => {
          if (response.status === 200) {
            vm.jobList = response.data;
          }
        })
        .catch((error) => {
          vm.$notify({
            title: "職缺列表取得失敗",
            message: error.response.data,
            type: "error",
            duration: 0,
          });
        });
    },

    // 我要應徵
    apply(demandNo) {
      localStorage.setItem("ManpowerDemandNo", demandNo);
      localStorage.setItem("path", "QRcode");
      this.$router.push({ path: "/candidate/form" });
    },

    getSSOLogin() {
      const vm = this;
      const api = `${window.endpoints.api}/auth/sso/login`;

      vm.$http
        .get(api)
        .then((response) => {
          if (response.status === 200) {
            const token = response.data;
            const decoded = jwt_decode(token);
            vm.$cookies.set("AUTH_TOKEN", token, Infinity);
            vm.$cookies.set("Account", decoded.Account, Infinity);
            vm.$cookies.set("userId", decoded.sub, Infinity);
            vm.$cookies.set("userName", decoded.UserName, Infinity);
            
            vm.$router.push({ path: "/manager/index" });
          }
        })
        .catch((error) => {
          vm.$notify({
            title: "登入失敗",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },
  },

  created() {
    this.getSSOLogin();
    this.getCarousel();
    this.getBlock();
    this.$set(this.searchCondition, "workPlace", null);
    this.getJobList();

    // 取得工作地點
    this.get_workplace()
      .then((result) => {
        this.workPlaceList = result;
      })
      .catch((error) =>
        this.$notify({
          title: "工作地點列表取得失敗",
          message: error.response.data,
          type: "error",
          duration: 3500,
        })
      );
  },
};
</script>

<style lang="scss" scoped>
.about-page {
  pre {
    font-size: 16px;
    white-space: pre-wrap;
    word-wrap: break-word;
  }
  font-family: "Quicksand", sans-serif;
  .carouselStyle {
    position: relative;

    /deep/.el-carousel {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
    }
    /deep/ .el-carousel__container {
      height: 100% !important;
    }
    .text-wrap {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      background-color: rgba(0, 0, 0, 0.3);
      z-index: 4;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);

      color: #fff;

      h1 {
        font-weight: bold;
        font-size: 3em;
      }
      h5 {
        letter-spacing: 3px;
        font-weight: bold;
      }
    }
    img {
      width: 100%;
    }

    .computer {
      display: block;
    }
    .mobile {
      display: none;
    }

    @media only screen and (max-width: 767px) {
      .computer {
        display: none;
      }
      .mobile {
        display: block;
      }
    }
  }

  .block-text {
    width: 100%;
    max-width: 960px;
    display: flex;
    margin: 40px auto;

    .text-wrap {
      .title {
        font-weight: bold;
        font-size: 2em;
        border-bottom: 5px solid #f54c4a;
        display: inline-block;
        margin-bottom: 10px;
      }
      width: 100%;
      background-color: #fff;
      padding: 40px;
      @media only screen and (max-width: 767px) {
        width: 100%;
      }
      .desc {
        line-height: 200%;
      }
    }
  }

  .block-img-right,
  .block-img-left {
    width: 100%;
    max-width: 960px;
    display: flex;
    margin: 40px auto;

    @media only screen and (max-width: 767px) {
      display: block;
    }

    &.block-img-left {
      flex-direction: row-reverse;
    }

    .text-wrap {
      .title {
        font-weight: bold;
        font-size: 2em;
        border-bottom: 5px solid #f54c4a;
        display: inline-block;
        margin-bottom: 10px;
      }
      width: 50%;
      background-color: #fff;
      padding: 40px;
      @media only screen and (max-width: 767px) {
        width: 100%;
      }
      .desc {
        line-height: 200%;
      }
      pre {
        font-size: 16px;
        white-space: pre-wrap;
        word-wrap: break-word;
      }
    }
    .img-wrap {
      flex: 1;
      min-width: 1px;
      img {
        max-width: 100%;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }

  .job-section {
    background-image: url("~@/assets/img/homePage/background.jpg");
    background-size: cover;
    padding-top: 100px;
    padding-bottom: 60px;
    background-attachment: fixed;
    background-position: center center;

    .title {
      text-align: center;
      span {
        font-weight: bold;
        font-size: 2em;
        border-bottom: 5px solid #f54c4a;
        display: inline-block;
        color: #fff;
        margin-bottom: 40px;
        text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);
      }
    }
    .job-list {
      max-width: 960px;
      margin: 0 auto;
      @media only screen and (max-width: 767px) {
        padding: 0 20px;
      }

      .job {
        display: flex;
        border-radius: 5px;
        box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
        background-color: rgba(#fff, 0.9);
        margin-bottom: 10px;
        padding: 15px 5px;
        color: #383838;
        text-decoration: none;
        align-items: center;
        @media only screen and (max-width: 767px) {
          display: block;
          padding: 20px;
          br {
            display: none;
          }
        }
        .date {
          font-weight: bold;
          padding: 15px;
          text-align: center;
          margin-right: 20px;
          color: #383838;
          border-right: 1px solid #bdbdbd;

          @media only screen and (max-width: 767px) {
            border-right: none;
            br {
              display: none;
            }
          }
          .year {
            font-size: 1.3em;
          }
        }
        .info {
          width: 800px;
          @media only screen and (max-width: 767px) {
            max-width: 300px;
          }
          .name {
            font-weight: bold;
            display: inline-block;
            margin-right: 5px;
            @media only screen and (max-width: 767px) {
              display: block;
              text-align: center;
              margin-bottom: 20px;
            }
          }
          .tag {
            display: inline-block;
            span {
              background-color: #f1f1f1;
              padding: 3px 10px;
              border-radius: 25px;
              margin-right: 8px;
              font-size: 0.9em;
            }
          }
          .money {
            display: inline-block;
            background-color: #f1f1f1;
            color: #f54c4a;
            padding: 3px 10px;
            border-radius: 25px;
          }
          .desc {
            margin-top: 10px;
            font-size: 0.9em;
            line-height: 175%;
            letter-spacing: 1px;
          }
        }

        .edit {
          margin-left: 10px;
          margin-right: 10px;
          button {
            background-color: #f54c4a;
            color: #ffffff;
            display: inline-block;
            padding: 7px;
            cursor: pointer;
            text-align: center;
            border: none;
            font-weight: bold;
            border-radius: 12px;
            width: 60px;
            height: 60px;
            text-decoration: none;
            box-shadow: 0 6px #f58684;

            word-wrap: break-word;

            &:hover {
              background-color: darken(#f54c4a, 10%);
            }
            &:active {
              background-color: #f54c4a;
              box-shadow: 0 3px #f53836;
              transform: translateY(4px);
            }
            @media only screen and (max-width: 767px) {
              width: 100%;
              height: auto;
            }
          }
        }
      }
    }
  }
}
</style>
